import * as React from 'react'
import { TextAreaField, TextAreaWrapper, OuterWrapper } from './styles'
import { TextAreaProps } from './types'
import { ErrorSpan, HelperText, Label } from '../styles'

const TextArea: React.FC<TextAreaProps> = React.forwardRef<HTMLTextAreaElement, TextAreaProps>(
  ({ label, required = false, error, helperText, isDisabled, isLoading, ...props }, ref) => {
    return (
      <OuterWrapper>
        <TextAreaWrapper>
          {label && <Label required={!!required}>{label}</Label>}
          <TextAreaField
            hasError={!!error}
            isDisabled={!!isLoading || !!isDisabled}
            rows={5}
            cols={60}
            ref={ref}
            {...props}
          />
        </TextAreaWrapper>
        {helperText && <HelperText>{helperText}</HelperText>}
        {error && <ErrorSpan>{error}</ErrorSpan>}
      </OuterWrapper>
    )
  }
)

export default TextArea
